import BasicLayout from "@container/layout/basic";
import ResetPasswordForm from "@container/reset-password";
import { useParams, Link } from "react-router-dom";

export default function ResetPasswordPage() {
    const { token = "" } = useParams();

    // In a real application, you would validate the token here
    // For example, check if it's valid, not expired, etc.
    const isValidToken = token && token.length > 0;

    if (!isValidToken) {
        return (
            <div className="w-full max-w-md mx-auto text-center">
                <div className="bg-white dark:bg-gray-800 shadow rounded-lg p-8">
                    <h2 className="text-2xl font-bold mb-4">Invalid or Expired Link.</h2>
                    <p className="text-gray-600 dark:text-gray-400 mb-6">
                        The password reset link is invalid or has expired. Please request a
                        new password reset link.
                    </p>
                    <Link
                        to="/forgot-password"
                        className="inline-block bg-indigo-600 hover:bg-indigo-700 text-white font-medium py-2 px-4 rounded"
                    >
                        Request New Link
                    </Link>
                </div>
            </div>
        );
    }

    return (
        <BasicLayout showFooter={false}>
            <div className="w-full max-w-md mx-auto px-4 md:px-0">
                <ResetPasswordForm token={token} />
            </div>
        </BasicLayout>
    );
}
